/* eslint-disable */
import { lazy } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';

//Guards
import GuestGuard from 'utils/route-guard/GuestGuard';
import AuthGuard from 'utils/route-guard/AuthGuard';
import ApprovedGuard from 'utils/route-guard/ApprovedGuard';

// project imports
import MainLayout from 'layout/MainLayout';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import Leave from 'views/attendance/leave';
import Attendance from 'views/attendance/attendance';
import VerificationPending from 'views/profile/VerificationPending';
import Holiday from 'views/attendance/holiday';
import RoleBasedGuard from 'utils/route-guard/RoleBasedGuard';
import { roles } from 'store/constant';
import CompanyDetails from 'views/company';
import ManageListing from 'views/dashboard/Management/ManageListings';
import CreateListing from 'views/dashboard/Management/CreateListings';
import CreateListingNew from 'views/dashboard/Management/CreateListingsNew';
import ListingDetails from 'views/dashboard/Management/ListingDetails';
import AmManageUsers from 'views/dashboard/ApartmentManagers/Users/AmManageUsers';
import AmManageListings from 'views/dashboard/ApartmentManagers/Listing/AmManageListings';
import RmManageUsers from 'views/dashboard/RegionalManagers/Users/RmManageUsers';
import RmSharedListings from 'views/dashboard/RegionalManagers/Listing/RmSharedListings';
import ArchievedListing from 'views/dashboard/Management/ArchivedListings';
import TrashedListing from 'views/dashboard/Management/TrashedListings';
import SystemSettings from 'views/profile/Profile1/SystemSettings';
import ManageComplexes from 'views/profile/Profile1/ManageComplex';
import { Box } from '@mui/material';
// import SampleComp from 'views/signature/signature';
// import HTMLToPdf from 'views/signature/htmlToPdf';
// import RichText from 'views/richtext';
// import LetterTemplates from 'views/dashboard/templates';
// import SignaturePad from 'views/signature/signature'; //

// login routing
const Register = Loadable(lazy(() => import('views/pages/authentication/authentication1/Register1')));
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication1/Login1')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication1/ForgotPassword1')));
const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/authentication1/ResetPassword1')));
const AuthCreatePassword = Loadable(lazy(() => import('views/pages/authentication/authentication1/CreatePassword1')));

const UserDetails = Loadable(lazy(() => import('views/pages/user/index')));
const UserProfile = Loadable(lazy(() => import('views/profile/Profile1/index')));

// dashboard routing
const ShoternUrlPage = Loadable(lazy(() => import('views/pages/landing/shoternUrl')));
const LandingPage = Loadable(lazy(() => import('views/pages/landing/index')));
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const DashboardAnalytics = Loadable(lazy(() => import('views/dashboard/Analytics')));

const EmployeesList = Loadable(lazy(() => import('views/dashboard/Employees/EmployeesList')));
const EmployeeAddEditForm = Loadable(lazy(() => import('views/dashboard/Employees/EmployeeAddEditForm')));

const ShiftAddEdit = Loadable(lazy(() => import('views/dashboard/shift-management/Shifts/index')));
const EmployeeShift = Loadable(lazy(() => import('views/dashboard/shift-management/employee-shifts/index')));

// attendance routing
const CheckIn = Loadable(lazy(() => import('views/attendance/checkin/index')));

// client routing
const ClientList = Loadable(lazy(() => import('views/dashboard/Clients/ClientList')));

//Payroll
const PayrollList = Loadable(lazy(() => import('views/dashboard/Payroll/payroll/PayrollList')));
const SalarySlips = Loadable(lazy(() => import('views/dashboard/Payroll/payroll/SalarySlips')));
const UpdatePayroll = Loadable(lazy(() => import('views/dashboard/Payroll/payroll/UpdatePayroll')));
const SalaryStructureHistory = Loadable(lazy(() => import('views/dashboard/Payroll/Salary/history/SalaryStructureHistory')));

// logger listt
const LoggerList = Loadable(lazy(() => import('views/dashboard/logger/LoggerList')));

const SalaryAddEditForm = Loadable(lazy(() => import('views/dashboard/Payroll/Salary/SalaryAddEditForm')));
const BonusAddEditForm = Loadable(lazy(() => import('views/dashboard/Payroll/Bonus/BonusAddEditForm')));

// Letter Templates
const LetterTempatesList = Loadable(lazy(() => import('views/dashboard/templates/index')));
const LetterTempatesEditCreate = Loadable(lazy(() => import('views/dashboard/templates/CreateEditTemplate')));

// Employees
const SendEmployeeLetter = Loadable(lazy(() => import('views/dashboard/Employees/letters/SendLetter')));
const EmployeeDigitalSignature = Loadable(lazy(() => import('views/dashboard/Employees/digital-signature/DigitalSignature')));

// Documents
const DocumentsList = Loadable(lazy(() => import('views/dashboard/Documents')));
const RequestsList = Loadable(lazy(() => import('views/dashboard/Requests')));

// Invoice
const AppCustomerCreateInvoice = Loadable(lazy(() => import('views/application/customer/CreateInvoice')));
const AppCustomerDetailInvoice = Loadable(lazy(() => import('views/application/customer/OrderDetails')));
const CustomerInvoiceList = Loadable(lazy(() => import('views/profile/Profile1/MyInvoice')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([
        {
            path: '/',
            children: [
                {
                    element: (
                        <GuestGuard>
                            <LandingPage />
                        </GuestGuard>
                    ),
                    index: true
                },
                {
                    element: (
                        <GuestGuard>
                            <AuthLogin />
                        </GuestGuard>
                    ),
                    path: 'login'
                },
                {
                    element: (
                        <GuestGuard>
                            <Register />
                        </GuestGuard>
                    ),
                    path: 'register'
                },
                {
                    element: <ShoternUrlPage />,
                    path: 'r'
                }
            ]
        },
        {
            path: 'auth',
            children: [
                {
                    element: (
                        <GuestGuard>
                            <AuthForgotPassword />
                        </GuestGuard>
                    ),
                    path: 'forgot-password'
                },
                {
                    element: (
                        <GuestGuard>
                            <AuthResetPassword />
                        </GuestGuard>
                    ),
                    path: 'reset-password'
                },
                {
                    element: (
                        <GuestGuard>
                            <AuthCreatePassword />
                        </GuestGuard>
                    ),
                    path: 'create-password'
                }
            ]
        },

        {
            path: 'user',
            children: [
                {
                    path: 'details',
                    element: (
                        <AuthGuard>
                            <MainLayout />
                        </AuthGuard>
                    ),
                    children: [
                        {
                            path: '',
                            element: <UserDetails />
                        }
                    ]
                },
                {
                    path: 'account-profile',
                    element: (
                        <AuthGuard>
                            <MainLayout />
                        </AuthGuard>
                    ),
                    children: [
                        {
                            path: '',
                            element: <UserProfile />
                        }
                    ]
                },
                {
                    path: 'system-settings',
                    element: (
                        <AuthGuard>
                            <MainLayout />
                        </AuthGuard>
                    ),
                    children: [
                        {
                            path: '',
                            element: <SystemSettings />
                        }
                    ]
                }
            ]
        },
        {
            path: 'complex',
            children: [
                {
                    path: 'manage-complexes',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.APARTMENT_MANAGER, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.VISITOR]}>
                            <MainLayout />
                        </RoleBasedGuard>
                    ),
                    children: [
                        {
                            path: '',
                            element: <ManageComplexes />
                        }
                    ]
                }
            ]
        },
        {
            path: 'user',
            element: <MainLayout />,
            children: [
                {
                    path: 'not-approved',
                    element: <VerificationPending />
                }
            ]
        },
        {
            path: 'company',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                {
                    path: 'details',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE, roles.HR]}>
                            <CompanyDetails />
                        </RoleBasedGuard>
                    )
                }
            ]
        },
        {
            path: 'dashboard',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                // {
                //     path: 'default',
                //     element: (
                //         <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
                //             <DashboardDefault />
                //         </RoleBasedGuard>
                //     )
                // },
                {
                    path: 'analytics',
                    element: (
                        <RoleBasedGuard message>
                            <DashboardAnalytics />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'analytics/:id',
                    element: (
                        <RoleBasedGuard message>
                            <DashboardDefault />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'clients',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE, roles.HR]}>
                            <ClientList />
                        </RoleBasedGuard>
                    )
                }
            ]
        },
        {
            path: 'scraper',
            element: (
                <Box sx={{ m: 3 }}>
                    <Outlet />
                </Box>
            ),
            children: [
                {
                    path: 'analytics',
                    element: (
                        <RoleBasedGuard message>
                            <DashboardAnalytics />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'analytics/:id',
                    element: (
                        <RoleBasedGuard message>
                            <DashboardDefault />
                        </RoleBasedGuard>
                    )
                }
            ]
        },
        {
            path: 'customers',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                {
                    path: 'list',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
                            <EmployeesList />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'add',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
                            <EmployeeAddEditForm />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: ':id',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
                            <EmployeeAddEditForm />
                        </RoleBasedGuard>
                    )
                }
            ]
        },
        {
            path: 'invoices',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                {
                    path: 'add',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
                            <AppCustomerCreateInvoice />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: ':id',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
                            <AppCustomerCreateInvoice />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'invoices-list',
                    element: (
                        <RoleBasedGuard message>
                            <CustomerInvoiceList />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'invoices-details/:id/:userId',
                    element: (
                        <RoleBasedGuard message>
                            <AppCustomerDetailInvoice />
                        </RoleBasedGuard>
                    )
                }
            ]
        },
        {
            path: 'customers/digital-sign',
            element: <EmployeeDigitalSignature />
        },

        {
            path: 'letter-templates',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                {
                    path: 'list',
                    element: (
                        <RoleBasedGuard restrictedRoles={[roles.EMPLOYEE]}>
                            <LetterTempatesList />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'create',
                    element: (
                        <RoleBasedGuard restrictedRoles={[roles.EMPLOYEE]}>
                            <LetterTempatesEditCreate />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'edit/:template_id',
                    element: (
                        <RoleBasedGuard restrictedRoles={[roles.EMPLOYEE]}>
                            <LetterTempatesEditCreate isEdit />
                        </RoleBasedGuard>
                    )
                }
            ]
        },
        {
            path: 'listing',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                {
                    path: 'add',
                    element: (
                        <RoleBasedGuard>
                            <CreateListingNew />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: ':id',
                    element: (
                        <RoleBasedGuard>
                            <CreateListingNew />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'details/:id',
                    element: (
                        <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
                            <ListingDetails />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'archived-listing',
                    element: <ArchievedListing />
                },
                {
                    path: 'manage-listing',
                    element: <ManageListing />
                },
                {
                    path: 'trashed-listing',
                    element: <TrashedListing />
                }
            ]
        },
        {
            path: 'ams',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                {
                    path: 'manage-users',
                    element: (
                        <RoleBasedGuard>
                            <AmManageUsers />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'manage-listing',
                    element: <AmManageListings />
                }
            ]
        },
        {
            path: 'rms',
            element: (
                <ApprovedGuard>
                    <MainLayout />
                </ApprovedGuard>
            ),
            children: [
                {
                    path: 'manage-users',
                    element: (
                        <RoleBasedGuard>
                            <RmManageUsers />
                        </RoleBasedGuard>
                    )
                },
                {
                    path: 'shared-listing',
                    element: (
                        <RoleBasedGuard>
                            <RmSharedListings />
                        </RoleBasedGuard>
                    )
                }
            ]
        }
        // {
        //     path: 'attendance',
        //     element: (
        //         <ApprovedGuard>
        //             <MainLayout />
        //         </ApprovedGuard>
        //     ),
        //     children: [
        //         {
        //             path: 'list',
        //             element: <Attendance />
        //         },
        //         {
        //             path: 'checkin',
        //             element: <CheckIn />
        //         },
        //         {
        //             path: 'leave',
        //             element: <Leave />
        //         },
        //         {
        //             path: 'holiday',
        //             element: <Holiday />
        //         }
        //     ]
        // },
        // {
        //     path: 'payroll',
        //     element: (
        //         <ApprovedGuard>
        //             <MainLayout />
        //         </ApprovedGuard>
        //     ),
        //     children: [
        //         {
        //             path: 'list',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <PayrollList />
        //                 </RoleBasedGuard>
        //             )
        //         },
        //         {
        //             path: 'salary-slips',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <SalarySlips />
        //                 </RoleBasedGuard>
        //             )
        //         },
        //         {
        //             path: 'salary/add/:id',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <SalaryAddEditForm />
        //                 </RoleBasedGuard>
        //             )
        //         },
        //         {
        //             path: 'salary/view/:id',
        //             element: <SalaryAddEditForm comingFromSalaryHistory viewOnly />
        //         },
        //         {
        //             path: 'salary/edit/:id',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <SalaryAddEditForm />
        //                 </RoleBasedGuard>
        //             )
        //         },
        //         {
        //             path: 'salary/history/edit/:id',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <SalaryAddEditForm comingFromSalaryHistory />
        //                 </RoleBasedGuard>
        //             )
        //         },
        //         {
        //             path: 'salary/history/:id',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <SalaryStructureHistory />
        //                 </RoleBasedGuard>
        //             )
        //         },
        //         {
        //             path: 'bonus/add/:id',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <BonusAddEditForm />
        //                 </RoleBasedGuard>
        //             )
        //         },
        //         {
        //             path: 'bonus/edit/:id',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE]}>
        //                     <BonusAddEditForm />
        //                 </RoleBasedGuard>
        //             )
        //         }
        //     ]
        // },
        // {
        //     path: 'documents',
        //     element: (
        //         <ApprovedGuard>
        //             <MainLayout />
        //         </ApprovedGuard>
        //     ),
        //     children: [
        //         {
        //             path: 'list',
        //             element: (
        //                 <ApprovedGuard>
        //                     <DocumentsList />
        //                 </ApprovedGuard>
        //             )
        //         }
        //     ]
        // },
        // {
        //     path: 'logger',
        //     element: (
        //         <ApprovedGuard>
        //             <MainLayout />
        //         </ApprovedGuard>
        //     ),
        //     children: [
        //         {
        //             path: 'list',
        //             element: (
        //                 <RoleBasedGuard message restrictedRoles={[roles.EMPLOYEE, roles.HR]}>
        //                     <LoggerList />
        //                 </RoleBasedGuard>
        //             )
        //         }
        //     ]
        // },
        // {
        //     path: 'requests',
        //     element: (
        //         <ApprovedGuard>
        //             <MainLayout />
        //         </ApprovedGuard>
        //     ),
        //     children: [
        //         {
        //             path: 'list',
        //             element: (
        //                 <ApprovedGuard>
        //                     <RequestsList />
        //                 </ApprovedGuard>
        //             )
        //         }
        //     ]
        // }
    ]);
}
